import { useDispatch, useSelector } from 'react-redux';

import { loadListingApplicationsTabData } from '../../../actions/initListingActionCreators';

import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import ErrorBanner from './ErrorBanner';
import LoadingScreen from '../../../components/LoadingScreen/LoadingScreen';
import useQueryVariables from '../../../hooks/useQueryVariables';
import Enrollment from '../../../components/Enrollment/Enrollment';
import ListingApplications from './ListingApplications/ListingApplications';
import { getNeedsToIdVerifySelector } from '../../../selectors';
import { useZgGraphqlQuery } from '../../../hooks/useGraphqlQuery';
import { APPLICATION_ELIGIBILTY_STATUSES } from '../../../constants/rentGuarantee';
import { LISTING_APPLICATIONS_QUERY, MARK_APPLICATIONS_AS_VIEWED_MUTATION } from '../../../constants/queries';
import { useZgGraphqlMutation } from '../../../hooks/useGraphqlMutation';
import { emitViewListingPageEvent } from '../../../../client/analytics/clickstreamEvents';
import { useListingUser } from '../../../hooks/useListingUser';

function getApplicationsEligibiltiesMap(data) {
  if (!data) {
    return {};
  }
  return data.rentalListing.landlordRentalApplications.reduce((acc, landlordRentalApplication) => {
    const { id, isIncomeToRentEligible, isIncomeToRentVerified } = landlordRentalApplication;
    if (!isIncomeToRentVerified) {
      acc[id] = APPLICATION_ELIGIBILTY_STATUSES.NOT_VERIFIED;
      return acc;
    }
    acc[id] = isIncomeToRentEligible
      ? APPLICATION_ELIGIBILTY_STATUSES.ELIGIBLE
      : APPLICATION_ELIGIBILTY_STATUSES.INELIGIBLE;
    return acc;
  }, {});
}

export default function ListingApplicationsTab({ listing }) {
  const loadingScreenStatus = useSelector((state) => state.rentalApplication.loadingStatus.loadingScreenStatus);
  const dispatch = useDispatch();
  const { propertyId: listingAlias } = useQueryVariables();
  const { user } = useListingUser();
  const needsToIdVerify = useSelector(getNeedsToIdVerifySelector());
  const { isLoading, data, applicationsError } = useZgGraphqlQuery(LISTING_APPLICATIONS_QUERY, {
    listingAlias,
    isActive: true,
    needsToIdVerify,
  });

  useEffect(() => {
    emitViewListingPageEvent(user);
  }, []);

  const applicationEligibilitiesMap = getApplicationsEligibiltiesMap(data);

  const { mutate: markApplicationsAsViewed } = useZgGraphqlMutation(MARK_APPLICATIONS_AS_VIEWED_MUTATION);

  // marks all applications as viewed once we leave this page
  useEffect(() => {
    return () => markApplicationsAsViewed({ listingAlias });
  }, [markApplicationsAsViewed, listingAlias]);

  useEffect(() => {
    dispatch(loadListingApplicationsTabData());
  }, [dispatch]);

  if (isLoading) {
    return <LoadingScreen isLoading {...loadingScreenStatus} />;
  }

  return (
    <section className="ApplicationsTab">
      <ErrorBanner error={applicationsError} />
      <Enrollment listing={listing} />
      <ListingApplications
        data={data}
        error={applicationsError}
        applicationEligibilitiesMap={applicationEligibilitiesMap}
      />
    </section>
  );
}

ListingApplicationsTab.propTypes = {
  listing: PropTypes.object,
};
